<template lang="pug">
.v-favorites.favorites(v-if="favorites")
	.favorites__container.container
		v-title.favorites__title-wrapper(v-if="favorites.title" :title="favorites.title")
		template(v-if="favorites.items && favorites.items.length")
			.favorites__wrapper
				.favorites__item(v-for="(item, itemIndex) in favorites.items" :key="itemIndex")
					.product-slider__favorite-action
						v-favorite-action(:id="item.id" :name="item.name" :model="item.model")
					v-product(:product="item")
		template(v-else)
			.favorites__empty-wrapper
				img.favorites__empty-image(:src="favorites.imagePlaceholder || imagePlaceholder"
						alt=""
						loading="lazy")
				.favorites__empty-text {{favorites.textPlaceholder || textPlaceholder}}
				a.btn.favorites__empty-btn(v-if="favorites.emptyLink"
						:href="favorites.emptyLink")
					| {{favorites.btnText || btnText}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import {mapGetters} from "vuex";

export default {
	mixins: [
		sourceMixin,
	],

	data() {
		return {
			favorites: null,
			imagePlaceholder: '/local/assets/images/favorites-placeholder.png',
			textPlaceholder: 'Тут будут сохраненные объявления',
			btnText: "Подобрать авто"
		};
	},


	computed: {
		...mapGetters({
			favoriteCount: 'favorite/favoriteCount',
		}),
	},

	watch: {
		favoriteCount() {
			this.requestDataLoad();
		},
	},

	methods: {
		requestDataLoad() {
			if (this.favorites && this.favorites.remote) {
				this.dataLoad({
					url: this.favorites.remote,
					delay: true,
				});
			}
		},

		dataSet(data) {
			this.favorites = data;
		}
	}
};
</script>